import axios from 'axios';

const CSRF_COOKIE_NAME = 'csrftoken';
const CSRF_HEADER_NAME = 'X-CSRFToken';

import app from '../main';

const session = axios.create({
  xsrfCookieName: CSRF_COOKIE_NAME,
  xsrfHeaderName: CSRF_HEADER_NAME,
  baseURL: 'https://api.sessaodatarde.net',
});

session.interceptors.request.use((config) => {
    app.$Progress.start(); 
    return config;
});


session.interceptors.response.use((response) => {
    app.$Progress.finish();
    return response;
}, function (error) {
    app.$Progress.fail(); 
    return Promise.reject(error.response);
});

export default session;
